import { render, staticRenderFns } from "./gates.vue?vue&type=template&id=4de7767d&scoped=true"
import script from "./gates.vue?vue&type=script&lang=js"
export * from "./gates.vue?vue&type=script&lang=js"
import style0 from "./gates.vue?vue&type=style&index=0&id=4de7767d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de7767d",
  null
  
)

export default component.exports